import React from 'react';
import cx from 'classnames';
import { Menu } from '../Menu';
import { Content } from '../Content';
import { CardList } from '../CardList';
import styles from './index.scss';

interface FrameworkProps {
  className?: string;
  direction?: 'horizontal' | 'vertical';
  block?: number;
  item?: number;
  showLeft?: boolean;
  showContent?: boolean;
  showRight?: boolean;
}

export const Framework = ({
  className,
  direction = 'vertical',
  block = 1,
  item = 8,
  showLeft = true,
  showContent = true,
  showRight = false,
}: FrameworkProps) => {
  return (
    <section className={cx(styles.Framework, className)}>
      {showLeft && <Menu className={styles.frameworkLeft} />}
      {showContent && (
        <div className={styles.FrameworkContent}>
          {Array(block)
            .join(' ')
            .split(' ')
            .map((_, i) => (
              <CardList key={i} direction={direction} size={item} />
            ))}
        </div>
      )}
      {showRight && (
        <div className={styles.FrameworkRight}>
          <div>
            <Content />
            <Content />
            <Content />
          </div>
          <div>
            <Content />
            <Content />
            <Content />
          </div>
        </div>
      )}
    </section>
  );
};
